<!--
 * @Author: FengHang
 * @LastEditors: FengHang
 * @Date: 2021-06-04 18:10:10
 * @LastEditTime: 2021-06-10 17:09:19
-->
<template>
	<div class="">
		<van-pull-refresh class="applyed" v-model="fresh" @refresh="onRefresh">
			<van-list offset="10" v-model="loadMore" :finished="loadFinish"
				:finished-text="jobData.length >= 5?'没有更多了':''" @load="scrollToLower">
				<div class="applyed-top">
					<div class="applyed-top-content">
						<span class="top-content-title">{{headTitle}}</span>
						<div class="top-content-unit">
							<span class="content-unit-num">{{totalCount}}</span>
							<span class="content-unit-text">个</span>
						</div>
					</div>
					<img class="applyed-top-icon" src="@/assets/images/mobile/student/icon4.png" alt="">
				</div>
				<div class="applyed-data">
					<jobList :importArea="'student'" :jobList="jobData" :showEmpty="showEmpty"/>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	import jobList from "../components/jobList.vue";
	import {
		jobListMb
	} from "@/api/mobile/activity";
	export default {
		components: {
			jobList
		},
		data() {
			return {
				jobData: [],
				headTitle: "",
				pageIndex: 1,
				pageSize: 6,
				totalCount: 0,
				fresh: false,
				loadMore: false,
				loadFinish: false,
				visitType: "",
				showEmpty: false
			}
		},
		watch: {},
		methods: {
			onRefresh() {
				this.pageIndex = 1
				setTimeout(() => {
					this.jobData = []
					this.getJobData()
				}, 1000);
			},
			scrollToLower() {
				// 加载状态结束
				if (this.totalCount > this.pageSize && this.pageIndex > 1) {
					this.getJobData()
				}
			},
			getJobData() {
				return new Promise((resolve, reject) => {
					this.loadFinish = false
					this.showEmpty = false
					let params = {
						pageIndex: this.pageIndex,
						pageSize: this.pageSize,
					}
					if (this.visitType == 'applyed') {
						this.$set(params, "querySignUp", true)
						// this.$set(params, "signUpStatus", "REGISTERING")
					} else if (this.visitType == 'employed') {
						this.$set(params, "signUpStatus", "ADMISSION")
					} else if (this.visitType == 'unemploy') {
						this.$set(params, "signUpStatus", "NO_ADMISSION")
					} else if (this.visitType == 'canceled') {
						this.$set(params, "signUpStatus", "CANCEL")
					} else if(this.visitType == 'interwiew'){
						this.$set(params, "signUpStatus", "INTERVIEW")
					}
					jobListMb(params).then((res) => {
						// console.log("getJobData", res)
						if (res.code == 0) {
							if (this.pageIndex == 1) {
								this.fresh = false;
							}
							this.loadMore = false
							res.data.forEach(item => {
								this.$set(item, "status", 1)
							})
							this.jobData = this.jobData.concat(res.data)
							this.totalCount = res.page.totalCount
							if (this.jobData.length >= res.page.totalCount * 1) {
								this.loadFinish = true
							}
							if (this.jobData.length == 0) {
								this.showEmpty = true
							}
							this.pageIndex++
							resolve()
						} else {
							this.loadMore = false
							this.loadFinish = true
							this.fresh = false
							this.showEmpty = false
							reject()
						}
					}).catch((err) => {
						this.loadMore = false
						this.loadFinish = true
						this.fresh = false
						this.showEmpty = false
						reject()
					})
				})
			},
		},
		mounted() {
			this.visitType = this.$route.query.visitType
			if (this.visitType == 'applyed') {
				this.headTitle = "已报名岗位"
			} else if (this.visitType == 'employed') {
				this.headTitle = "已录用岗位"
			} else if (this.visitType == 'unemploy') {
				this.headTitle = "未录用岗位"
			} else if (this.visitType == 'canceled') {
				this.headTitle = "已取消报名岗位"
			}else if(this.visitType=='interwiew'){
				this.headTitle = "面试中岗位"
			}
			this.getJobData()
			if (this.$dd.env.platform !== "notInDingTalk") {
				this.$dd.ready(() => {
					// 设置标题
					dd.biz.navigation.setTitle({
						title: this.headTitle, //控制标题文本，空字符串表示显示默认文本
						onSuccess: function(result) {},
						onFail: function(err) {}
					});
				})
			}
		},
	}
</script>
<style lang="scss" scoped>
	.applyed {
		height: 100%;
		display: flex;
		flex-direction: column;
		// padding: 0.28rem 0.28rem;
		// box-sizing: border-box;

		.applyed-top {
			width: 6.94rem;
			height: 1.76rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-image: url("../../../assets/images/mobile/student/bg1.png");
			background-size: 100% 100%;
			background-repeat: no-repeat;
			margin: 0.28rem 0.28rem;
			box-sizing: border-box;

			.applyed-top-content {
				display: flex;
				flex-direction: column;
				margin-left: 0.4rem;

				.top-content-title {
					font-size: 0.28rem;
					font-family: PingFang SC;
					font-weight: bold;
					line-height: 0.4rem;
					color: #FFFFFF;
				}

				.top-content-unit {
					display: flex;
					align-items: flex-end;

					.content-unit-num {
						font-size: 0.56rem;
						font-family: DIN Alternate;
						font-weight: bold;
						line-height: 0.64rem;
						color: #FFFFFF;
					}

					.content-unit-text {
						font-size: 0.28rem;
						font-family: PingFang SC;
						font-weight: bold;
						line-height: 0.4rem;
						color: rgba(255, 255, 255, 0.6);
					}
				}
			}

			.applyed-top-icon {
				width: 1.06rem;
				height: 1.06rem;
				margin-right: 0.64rem;
			}
		}

		.applyed-data {
			flex: 1;
		}
	}
</style>
